import { render, staticRenderFns } from "./ClassNoteLessonQuestionSetup.vue?vue&type=template&id=3a5d69fc"
import script from "./ClassNoteLessonQuestionSetup.vue?vue&type=script&lang=js"
export * from "./ClassNoteLessonQuestionSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports